__turbopack_context__.v({
  "no-background": "promotional-text-module-scss-module__ZIjUwG__no-background",
  "promotional-card": "promotional-text-module-scss-module__ZIjUwG__promotional-card",
});
